import { ParamsDataPerfilUser } from 'utils/typeServices';
import { ProfileVersionEnum } from 'utils/enums';
import { LoadConfig } from 'utils/loadConfig';
import { ParseCivilStatus, ParseInsuredBond, ParseTaxExemptionReason, ParseVehicleUse } from 'core/dataPerfilQuotation';

type ParamsDsPerfil = {
    key: string;
    value: string;
}

const parseYesNo = (value?: string) => value === "Sim" ? "1" : "0";

const parseSex = (value?: string) => {
    switch ((value || '').toUpperCase()) {
        case 'M':
        case 'MASCULINO':
            return 'masculino';
        case 'F':
        case 'FEMININO':
            return 'feminino';
        default:
            return '';
    }
}

const parseLicenseTime = (value?: string) => {
    switch (value) {
        case 'Até 2 anos':
            return '2_anos';
        case 'Mais que 2 anos':
            return 'mais_2_anos';
        default:
            return value || '';
    }
}

export const ParseProfileVersion = (dataPerfil: ParamsDataPerfilUser) => {
    if (LoadConfig()?.NEW_VERSION_QAR_ACTIVE !== true) {
        return ProfileVersionEnum.OldVersion;
    }

    return dataPerfil?.NR_VERSAO_PERFIL === ProfileVersionEnum.NewVersion ? ProfileVersionEnum.NewVersion : ProfileVersionEnum.OldVersion;
};

export const ParsePerfilQuotation = (dataPerfil: ParamsDataPerfilUser) => {
    const isNewVersion = ParseProfileVersion(dataPerfil) === ProfileVersionEnum.NewVersion;
    const vehicleUse = ParseVehicleUse(dataPerfil.UTILIZACAO_VEICULO).value;
    const isTaxi = vehicleUse === 'taxi';

    const datePerfil: Array<ParamsDsPerfil> = [
        {
            key: "nascimento_segurado",
            value: dataPerfil.DT_NASCIMENTO,
        },
        {
            key: "sexo_segurado",
            value: parseSex(dataPerfil.SEXO),
        },
        {
            key: "estado_civil_segurado",
            value: ParseCivilStatus(dataPerfil.ESTADO_CIVIL).value,
        },
        {
            key: "condutor_menor_26",
            value: parseYesNo(dataPerfil.CONDUTOR_MENOR_26),
        },
        {
            key: "garagem_fechada",
            value: parseYesNo(dataPerfil.GARAGEM_FECHADA),
        },
        {
            key: "garagem_residencia",
            value: parseYesNo(dataPerfil.GARAGEM_RESIDENCIA),
        },
        {
            key: "garagem_trabalho",
            value: dataPerfil.GARAGEM_TRABALHO === "Sim" ? "1" :
                dataPerfil.GARAGEM_TRABALHO === "Não utiliza para ida ao trabalho" ? "2" : "0"
        },
        {
            key: "garagem_faculdade",
            value: dataPerfil.GARAGEM_FACULDADE === "Sim" ? "1" :
                dataPerfil.GARAGEM_FACULDADE === "Não utiliza para ida à escola/faculdade" ? "2" : "0"
        },
        {
            key: "transporte_trabalho",
            value: isTaxi ? "1" : parseYesNo(dataPerfil.TRANSPORTE_TRABALHO),
        },
        {
            key: "finalidade_uso_veiculo",
            value: vehicleUse,
        },
        {
            key: "segurado_principal_condutor",
            value: parseYesNo(dataPerfil.SEGURADO_PRINCIPAL_CONDUTOR),
        },
        {
            key: "segurado_proprietario_legal",
            value: parseYesNo(dataPerfil.SEGURADO_PROPRIETARIO_LEGAL),
        },
        {
            key: "cpf_condutor",
            value: dataPerfil.SEGURADO_PRINCIPAL_CONDUTOR === "Sim" ? "" : dataPerfil.CPF_CONDUTOR,
        },
        {
            key: "nome_condutor",
            value: dataPerfil.NOME_CONDUTOR || "",
        },
        {
            key: "data_nascimento_condutor",
            value: dataPerfil.DATA_NASCIMENTO_CONDUTOR || "",
        },
        {
            key: "sexo_condutor",
            value: parseSex(dataPerfil.SEXO_CONDUTOR),
        },
        {
            key: "estado_civil_condutor",
            value: ParseCivilStatus((dataPerfil.ESTADO_CIVIL_CONDUTOR || '').split('(')[0]).value,
        },
        {
            key: "vinculo_condutor_segurado",
            value: dataPerfil.VINCULO_CONDUTOR_SEGURADO ? ParseInsuredBond(dataPerfil.VINCULO_CONDUTOR_SEGURADO).value : '',
        },
        {
            key: "tempo_habilitacao",
            value: parseLicenseTime(dataPerfil.TEMPO_HABILITACAO),
        },
        {
            key: "isencao_imposto",
            value: isTaxi ? "1" : parseYesNo(dataPerfil.ISENCAO_IMPOSTO),
        },
        {
            key: "zero_km",
            value: parseYesNo(dataPerfil.ZERO_KM),
        },
        {
            key: "saida_concessionaria",
            value: dataPerfil.SAIDA_CONCESSIONARIA || '',
        },
        {
            key: "veiculo_kit_gas",
            value: parseYesNo(dataPerfil.VEICULO_KIT_GAS),
        },
        {
            key: "motivo_isencao_fiscal",
            value: isTaxi ? "taxi" : ParseTaxExemptionReason(dataPerfil.MOTIVO_ISENCAO_FISCAL).value,
        }
    ];

    if (isNewVersion) {
        datePerfil.push(
            {
                key: "tipo_veiculo",
                value: dataPerfil.TIPO_VEICULO || "",
            },
            {
                key: "atividade_veiculo",
                value: dataPerfil.ATIVIDADE_VEICULO || "",
            },
            {
                key: "veiculo_blindado",
                value: parseYesNo(dataPerfil.VEICULO_BLINDADO),
            },
            {
                key: "veiculo_rebaixado",
                value: parseYesNo(dataPerfil.VEICULO_REBAIXADO),
            },
            {
                key: "veiculo_tunado",
                value: parseYesNo(dataPerfil.VEICULO_TUNADO),
            }
        );
    } else {
        datePerfil.push({
            key: "veiculo_modificado",
            value: parseYesNo(dataPerfil.VEICULO_MODIFICADO || dataPerfil.BLINDADO),
        });
    }

    return datePerfil;
}
